<template>
  <div class="container">
    <h5 class="title is-5">Configure MQTT local access</h5>
    <div class="container has-text-left">
      <div class="block">
        <b-field label="Configuration">
          <b-input type="textarea" v-model="strLocalAccess"></b-input>
        </b-field>
      </div>
      <div class="buttons">
        <b-button type="is-danger" class="is-outlined" @click="handleAbort">Abort</b-button>
        <b-button type="is-success" :disabled="!validFields()" @click="handleSave">Save</b-button>
      </div>
      <hr/>
      <p>
        This is where you give MQTT access to other applications.
      </p>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BField from "buefy/src/components/field/Field";
  import BInput from "buefy/src/components/input/Input";
  import BButton from "buefy/src/components/button/Button";

  export default {
    components: {
      BButton,
      BInput,
      BField
    },
    name: "screen-configure-mqtt",
    data() {
      return {
        strLocalAccess: '[]'
      };
    },
    computed: {
      ...mapGetters('mqtt', ['localAccess'])
    },
    methods: {
      ...mapActions('mqtt', ['saveMQTTAccess']),
      validFields() {
        let foundWrongUser = false;
        try {
          const obj = JSON.parse(this.strLocalAccess);
          obj.forEach(user => {
            if (!user.username || !user.password) {
              foundWrongUser = true;
            }
          });
        } catch (e) {
          return false;
        }

        return !foundWrongUser;
      },
      handleAbort() {
        this.$router.push('/configure');
      },
      handleSave() {
        this.saveMQTTAccess(JSON.parse(this.strLocalAccess));
        this.$router.push('/configure');
      }
    },
    mounted() {
      if (this.localAccess) {
        const remapped = this.localAccess.map(item => {
          const elem = {...item};
          delete elem['id'];
          return elem;
        });
        this.strLocalAccess = JSON.stringify(remapped, null, 2);
      }
    }
  }
</script>

<style scoped>

</style>